import React from 'react';
import { ProviderMatchProviderV9 } from '@kyruus/types';
import { FormattedMessage } from '@kyruus/intl';
import orderBy from 'lodash/orderBy';

import ExpandableCardContainer from '../ExpandableCardContainer/expandable-card-container';
import { ExpertiseTitle } from './styles';
import Education from './education';
import BoardCertifications from './board-certifications';
import ClinicalTrials from './clinical-trials';
import { TrackingFunction } from '../../lib/tracking-utils';
import messages from '../../lib/messages';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';

interface ProviderExpertiseProps {
  provider: ProviderMatchProviderV9;
  track: TrackingFunction;
}

const ProviderExpertise = ({
  provider,
  track
}: ProviderExpertiseProps): React.ReactElement => {
  const sortedTraining = orderBy(
    provider.training,
    ['graduation_year'],
    ['desc']
  );
  const sortedBoardCertifications = orderBy(
    provider.board_certifications,
    ['year_certified'],
    ['desc']
  );

  const sortedClinicalTrials = orderBy(
    provider.clinical_trials,
    ['start_date'],
    ['desc']
  );

  return (
    <ExpandableCardContainer id="profile-expertise-section" track={track}>
      <ExpertiseTitle>
        <FormattedMessage {...messages.providerExpertiseTitle} />
      </ExpertiseTitle>
      {/* child components will not render if data does not exist or is empty */}
      <Education training={sortedTraining} />
      <BoardCertifications board_certifications={sortedBoardCertifications} />
      <ClinicalTrials clinicalTrials={sortedClinicalTrials} />
    </ExpandableCardContainer>
  );
};

export default withErrorBoundary(ProviderExpertise);
